import React, { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './App.scss';
import AppLayout from './components/Layouts/AppLayout';
import Loading from './components/Loading/Loading';
import ApiErrorModal from './components/Modals/ApiErrorModal';
import { setAppMounted } from './core/services/app/setAppMounted/setAppMounted.slice';
import { setPathname } from './core/services/app/setPathname/setPathname.slice';
import { setResponseInterceptor } from './core/services/axios';
import { setRemoteConfig } from './core/services/firebase/setRemoteConfig/setRemoteConfig.slice';
import { useAppDispatch, useAppSelector } from './core/services/hooks';
import { router } from './core/utilities/router';
import Helpers from './core/utilities/helpers';
import Constants from './core/utilities/constants';
import { getReward } from './core/services/reward/getReward/getReward.slice';

function App() {
  const isAppMounted = useAppSelector(
    (state) => state.app.setAppMounted.isMounted
  );
  const remoteConfigState = useAppSelector(
    (state) => state.firebase.setRemoteConfig
  );

  const getRewardState = useAppSelector((state) => state.reward.getReward);

  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    setResponseInterceptor(dispatch);
    dispatch(setRemoteConfig());
    dispatch(setAppMounted(true));

    const tempId = Helpers.getQueryParam(location, Constants.urlTempIdParam);
    const hash = Helpers.getQueryParam(location, Constants.urlHashParam);
    dispatch(getReward({ tempId, hash }));
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    dispatch(setPathname(location.pathname));
  }, [dispatch, location]);

  const isAppLoading = (): boolean => {
    return !isAppMounted || remoteConfigState.loading || getRewardState.loading;
  };

  const renderLoading = () => {
    return <Loading className="app-loading" fontSize={64} />;
  };

  const renderLayout = () => {
    return (
      <Routes>
        <Route element={<AppLayout />}>
          <Route path={router.HOME} element={<LazyHomePage />} />
          <Route path="*" element={<Navigate to={router.HOME} />} />
        </Route>
      </Routes>
    );
  };

  return (
    <div id="app">
      <Suspense fallback={renderLoading()}>
        {isAppLoading() ? renderLoading() : renderLayout()}
      </Suspense>
      <ApiErrorModal />
    </div>
  );
}

export default App;

const LazyHomePage = React.lazy(() => import('./pages/HomePage'));
